import { Card } from 'antd';
import AiBatchApplicationWorkspace from '@/components/payouts/AiBatchApplicationWorkspace';

export default function AiBatchApplications() {
  return (
    <Card title="AI 批量创建申请" styles={{ body: { padding: 16 } }}>
      <AiBatchApplicationWorkspace />
    </Card>
  );
}
